<div class="p-4">
  <div class="card-container bg-gray-100 border-round p-4">
    <div class="mr-5 flex align-items-center mb-3">
      <i class="pi pi-search-plus mr-2 text-3xl"></i>
      <div class="font-medium text-3xl text-900">Archived Session Search</div>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <div class="p-fluid grid formgrid">
        <div class="field col-12 md:col-6 lg:col-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-calendar inputId="dateRange" formControlName="dateRange" selectionMode="range" [readonlyInput]="true" dateFormat="dd/mm/yy" styleClass="w-full"></p-calendar>
              <label for="dateRange">Last Active Date</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
        <div class="field col-12 md:col-6 lg:col-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-multiSelect inputId="users" [options]="usersForFilter" formControlName="userIds" optionLabel="fullName" optionValue="id" placeholder="Select Users" styleClass="w-full"></p-multiSelect>
              <label for="users">Users in Session</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
        <div class="field col-12 md:col-6 lg:col-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-sitemap"></i></p-inputgroup-addon>
            <p-iftalabel>
              <p-dropdown inputId="resourceType" [options]="resourceTypesForFilter" formControlName="resourceType" optionLabel="resourceName" optionValue="resourceName" placeholder="Select Type" [showClear]="true" styleClass="w-full"></p-dropdown>
              <label for="resourceType">Resource Type</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
        <div class="field col-12 md:col-6 lg:col-3">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input pInputText inputId="businessObjectId" type="number" formControlName="businessObjectId" class="w-full" />
              <label for="businessObjectId">Business Object ID</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>
        <div class="field col-12">
          <label for="searchText" class="block mb-2">Search Messages</label>
          <p-inputGroup>
            <p-dropdown [options]="searchTypes" formControlName="searchType" optionLabel="label" optionValue="value"></p-dropdown>
            <input type="text" pInputText formControlName="searchText" placeholder="Enter search query...">
          </p-inputGroup>
        </div>
      </div>
      <div class="flex justify-content-end gap-2 mt-4">
        <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-outlined" (click)="resetSearch()"></p-button>
        <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
      </div>
    </form>
  </div>

  <div class="card mt-4">
      <p-divider></p-divider>
  
      <p-table [value]="archivedSessions" [lazy]="true" (onLazyLoad)="loadArchivedSessions($event)" [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [loading]="isLoading"
        styleClass="p-datatable-striped" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="sessionId">Session ID <p-sortIcon field="sessionId"></p-sortIcon></th>
            <th pSortableColumn="title">Title <p-sortIcon field="title"></p-sortIcon></th>
            <th>Users</th>
            <th pSortableColumn="lastActivity">Last Active <p-sortIcon field="lastActivity"></p-sortIcon></th>
            <th style="width: 8rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-session>
          <tr>
            <td>{{ session.sessionId }}</td>
            <td>{{ session.title }}</td>
            <td>
              <p-avatar-group>
                <p-avatar *ngFor="let user of session.users" [image]="user.profilePictureUrl || 'assets/default-avatar.png'" shape="circle" [pTooltip]="user.fullName"></p-avatar>
              </p-avatar-group>
            </td>
            <td>{{ session.lastActivity | date:'medium' }}</td>
            <td>
              <p-button icon="pi pi-eye" styleClass="p-button-rounded p-button-text" (click)="viewSession(session)"></p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center p-4">No archived sessions found matching your criteria.</td>
          </tr>
        </ng-template>
      </p-table>
  </div>
</div>
  
  <p-dialog header="Session History: {{selectedSession?.title}}" [(visible)]="isDialogVisible" [modal]="true" [style]="{width: '60vw', height: '80vh'}" [maximizable]="true">
    <div *ngIf="selectedSession" class="flex flex-column h-full">
      <p-scrollPanel [style]="{width: '100%', height: '100%'}">
        <div *ngFor="let message of selectedSession.chatMessages" class="mb-4">
          <div class="flex align-items-center mb-2">
            <p-avatar [image]="message.sender.profilePictureUrl || 'assets/default-avatar.png'" shape="circle" class="mr-2"></p-avatar>
            <span class="font-bold">{{ message.sender.fullName }}</span>
            <span class="text-sm text-color-secondary ml-auto">{{ message.timestamp | date:'short' }}</span>
          </div>
          <div class="surface-100 p-3 border-round" [innerHTML]="message.textContent"></div>
        </div>
      </p-scrollPanel>
    </div>
  </p-dialog>
  
  